import { render, staticRenderFns } from "./DeletePageButton.vue?vue&type=template&id=1764ac80&scoped=true"
import script from "./DeletePageButton.vue?vue&type=script&lang=js"
export * from "./DeletePageButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1764ac80",
  null
  
)

export default component.exports